import { useCallback, useEffect, useState, type ReactNode } from "react"
import { useInatividadeKiosk } from "./use-inatividade-kiosk"
import { DialogInatividadeTotem, MS_RESPOSTA_PADRAO } from "@/components/totem/dialog-inatividade"

export interface AvisoInatividadeProps {
    ativo: boolean
    msInatividade: number
    aoExpirar: () => void
    msResposta?: number
    mensagem?: (segundos: number) => ReactNode
    acaoSecundaria?: { rotulo: string; aoClicar: () => void }
}

export default function AvisoInatividade({ ativo, msInatividade, aoExpirar, msResposta = MS_RESPOSTA_PADRAO, mensagem, acaoSecundaria, }: AvisoInatividadeProps): JSX.Element {
    const [perguntando, setPerguntando] = useState(false)
    const perguntar = useCallback(() => setPerguntando(true), [])

    useInatividadeKiosk(ativo && !perguntando, perguntar, msInatividade)

    useEffect(() => {
        if (!ativo) setPerguntando(false)
    }, [ativo])

    return (
        <DialogInatividadeTotem
            aberto={perguntando && ativo}
            msResposta={msResposta}
            mensagem={
                mensagem ??
                ((segundos) => (
                    <>
                        Sem atividade, o totem volta à tela inicial em <strong>{segundos}s</strong>.
                    </>
                ))
            }
            acaoSecundaria={acaoSecundaria ?? { rotulo: 'Recomeçar agora', aoClicar: aoExpirar }}
            aoContinuar={() => setPerguntando(false)}
            aoExpirar={aoExpirar}
        />
    )
}
